import React, { Component } from 'react';
import Year from './Year';

export default class Years extends Component {
	_handleInputChange(e) {
        this.props.onChange(e);
    }
    getAnnualReportWaitingForApproval(year) {
        var _file = "";
        this.props.annualReportsWaitingForApproval.forEach(function(file) {
            if(parseInt(file.year)===parseInt(year)) {
                _file = file;
            }
        })
        return _file
    }
    getDonationWaitingForApproval(year) {
        var _file = "";
        this.props.donationsWaitingForApproval.forEach(function(file) {
            if(parseInt(file.year)===parseInt(year)) {
                _file = file;
            }
        })
        return _file
    }
    getCurrentAnnualReportForYear(year) {
        var _file = "";
        this.props.annualReports.forEach(function(file) {
            if(parseInt(file.year)===parseInt(year)) {
                _file = file;
            }
        })
        return _file
    }
    getCurrentDonationForYear(year) {
        var _file = [];
        this.props.donations.forEach(function(file) {
            if(parseInt(file.year)===parseInt(year)) {
                _file = file;
            }
        })
        return _file
    }
    getCurrentMembershipForYear(year) {
        var _membership = '';
        this.props.memberships.forEach(function(membership) {
            if(parseInt(membership.year)===parseInt(year)) {
                _membership = membership;
            }
        })
        return _membership
    }
    getAnnualReportCommunityForYear(year) {
        var _annualReport = '';
        if(this.props.annualReportsParent) {
            this.props.annualReportsParent.forEach(function(report) {
                if(parseInt(report.year)===parseInt(year)) {
                    _annualReport = report;
                }
            })
        }
        return _annualReport
    }
    getDonationCommunityForYear(year) {
        var _donation = '';
        if(this.props.donationsParent) {
            this.props.donationsParent.forEach(function(donation) {
                if(parseInt(donation.year)===parseInt(year)) {
                    _donation = donation;
                }
            })
        }
        return _donation
    }
	render() {
        let reports = [];
        this.props.years.forEach(function(year) {
            let currentAnnualReport = this.getCurrentAnnualReportForYear(year.year);
            let annualReportWaitingForApproval = this.getAnnualReportWaitingForApproval(year.year);
            let donationWaitingForApproval = this.getDonationWaitingForApproval(year.year);
            let currentDonation = this.getCurrentDonationForYear(year.year);
            let membership = this.getCurrentMembershipForYear(year.year);
            let annualReportCommunity = this.getAnnualReportCommunityForYear(year.year);
            let donationCommunity = this.getDonationCommunityForYear(year.year);
            if(year.year >= this.props.approvedAt) {
                reports.push(<Year
                    year={year.year}
                    updateUnlockedStatus={this.props.updateUnlockedStatus}
                    membershipsCount={membership ? membership.count : ''}
                    organizationType={this.props.organizationType}
                    organizationId={this.props.organizationId}
                    membershipId={membership ? membership.id : ''}
                    membershipLockedAt={membership ? membership.editing_locked_at : ''}
                    key={year.year}
                    onHandleAddMembersCount={this.props.onHandleAddMembersCount}
                    onHandlePrepareFileForUpload={this.props.onHandlePrepareFileForUpload}
                    formDataUpdated={this.props.formDataUpdated}
                    file={this.props.file}
                    file2={this.props.file2}
                    currentAnnualReportName={currentAnnualReport ? currentAnnualReport.filename : ''}
                    currentAnnualReportId={currentAnnualReport ? currentAnnualReport.id : ''}
                    currentAnnualReportInherited={currentAnnualReport ? currentAnnualReport.isInherited : ''}
                    currentAnnualReport={currentAnnualReport}
                    annualReportsWaitingForApproval={this.props.annualReportsWaitingForApproval}
                    annualReportWaitingForApproval={annualReportWaitingForApproval}
                    donationWaitingForApproval={donationWaitingForApproval}
                    currentDonation={currentDonation}
                    currentDonationName={currentDonation ? currentDonation.filename : ''}
                    currentDonationId={currentDonation ? currentDonation.id : ''}
                    onHandleFileDelete={this.props.onHandleFileDelete}
                    deleteDocumentFromServer={this.props.deleteDocumentFromServer}
                    user={this.props.user}
                    annualReportCommunity={annualReportCommunity ? annualReportCommunity.id : ''}
                    donationCommunity={donationCommunity ? donationCommunity : ''}
                    />)
            }
        }.bind(this));
		return(
			<div className="panel fullwidth">
                <h2>Indberetninger</h2>
                <p style={{margin: '1em 0 2em 0'}}>Når årsregnskaber og oplysninger om donationer er indberettet, låses indberetningen, og den kan ikke ændres. Oplysningerne vises på Trossamfundsregistrets hjemmeside. Ved fejl i indberetningen kontakt da By-, Land- og Kirkeministeriet på tlf. nr. 33 92 33 90, med sikker post via jeres digitale postkasse, der kan tilgås på www.virk.dk eller med ordinær post til By-, Land- og Kirkeministeriet, Frederiksholms Kanal 21, 1220 København K.</p>
				
            
                        <div className="flex px-4 gap-4">
                            <div className="flex-1 px-4 shrink text-2xl"><h4>Årsregnskab</h4></div>
                            <div className="flex-1 px-4 shrink text-2xl"><h4>Donationer</h4></div>
                            <div className="flex-1 px-4 shrink text-2xl"><h4>Antal medlemmer</h4></div>
                        </div>
                        {reports}
            
            </div>
      	);
	}
}


// WEBPACK FOOTER //
// ./src/modules/reports/Years.js